import { InputBase, ListItemText, MenuItem, Select } from '@material-ui/core';

import { appThemeApiRef, useApi } from '@backstage/core-plugin-api';

import { SelectListItem } from '@spotify/confidence-core-react';

export function ThemeSwitcher() {
  const appThemeApi = useApi(appThemeApiRef);
  const themes = appThemeApi.getInstalledThemes();
  const activeTheme = appThemeApi.getActiveThemeId();

  const handleSetTheme = (newThemeId: string | undefined) => {
    if (themes.some(it => it.id === newThemeId)) {
      appThemeApi.setActiveThemeId(newThemeId);
    } else {
      appThemeApi.setActiveThemeId(undefined);
    }
  };

  return (
    <SelectListItem>
      <ListItemText primary="Theme" />
      <Select
        value={activeTheme ?? ''}
        onChange={e => handleSetTheme(e.target.value as string)}
        input={<InputBase />}
        aria-label="Select color theme"
      >
        {themes.map(theme => (
          <MenuItem key={theme.id} value={theme.id}>
            {theme.title}
          </MenuItem>
        ))}
        <MenuItem value="">Auto</MenuItem>
      </Select>
    </SelectListItem>
  );
}
